import {
  AtlasBodyMain,
  AtlasCaption,
  CardComponent,
  TagMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { StackAtom } from 'components/atoms/Stack.atom'

interface ShipmentPalletCardOrganismProps {
  palletNumber: number
  totalPallets: number
  productCount: number
  container: string
  channel: string
  scanned?: boolean
}

export const ShipmentPalletCardOrganism = (
  props: ShipmentPalletCardOrganismProps
) => {
  const {
    palletNumber,
    totalPallets,
    productCount,
    container,
    channel,
    scanned = false
  } = props

  return (
    <CardComponent style={{ padding: '12px' }}>
      <StackAtom $justify="space-between" $align="center" $gap={24}>
        <CardComponent $variant="highlight" style={{ padding: '8px 12px' }}>
          <StackAtom $direction="column" $gap={12}>
            <StackAtom $justify="space-between" $align="center">
              <AtlasCaption style={{ fontWeight: 700 }}>
                Tarima {palletNumber} de {totalPallets}
              </AtlasCaption>

              <TagMolecule
                text={`${productCount}`}
                icon={<Icon name="ic_product" color="white" size={18} />}
              />
            </StackAtom>

            <StackAtom $direction="column" $gap={4}>
              <StackAtom $gap={4}>
                <Icon name="ic_scan_qr" size={18} color="white" />
                <AtlasBodyMain style={{ fontWeight: 700 }}>
                  {container}
                </AtlasBodyMain>
              </StackAtom>

              <StackAtom $gap={4}>
                <Icon name="ic_location" size={18} color="white" />
                <AtlasBodyMain>{channel}</AtlasBodyMain>
              </StackAtom>
            </StackAtom>
          </StackAtom>
        </CardComponent>

        <Icon
          name={scanned ? 'ic_check_circle_fill' : 'ic_check_circle_dark'}
          color={scanned ? '#21C043' : '#7A7A7A'}
          size={24}
        />
      </StackAtom>
    </CardComponent>
  )
}
